import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Adicionar")
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "ui-table"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-22 ant-col-xl-17 ui-cell" }, " Valor "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell" }, " Ativo "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-align-center" }, " Ações ")
], -1)
const _hoisted_8 = { class: "ui-rows ui-rolagem-padrao" }
const _hoisted_9 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-17 ui-cell",
  "data-title": "Valor"
}
const _hoisted_10 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell",
  "data-title": "Ativo"
}
const _hoisted_11 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-actions-table",
  "data-title": "Ações"
}
const _hoisted_12 = { class: "ui-actions" }
const _hoisted_13 = { class: "ui-action ui-move" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_form_item, { label: "Novo valor" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    ref: "campoNovoValor",
                    type: "text",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.novoValor) = $event)),
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.adicionarItem()), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.state.novoValor]
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_form_item, { label: " " }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "ui-button -primary ui-mh-32 ui-full",
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.adicionarItem()))
                  }, _hoisted_5)
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.computedItensListaSimples.length <= 0)
            ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                key: 0,
                mensagem: "Nenhum item foi adicionado ainda"
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_draggable, {
                    modelValue: _ctx.computedItensListaSimples,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedItensListaSimples) = $event)),
                    "item-key": "index",
                    handle: ".ui-move"
                  }, {
                    item: _withCtx(({element,index}) => [
                      (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "ant-row ui-row"
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_a_input, {
                            class: "ant-input",
                            value: element.valor,
                            "onUpdate:value": ($event: any) => ((element.valor) = $event)
                          }, null, 8, ["value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_selecionar_sim_nao, {
                            valor: element.status,
                            "onUpdate:valor": ($event: any) => ((element.status) = $event)
                          }, null, 8, ["valor", "onUpdate:valor"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_a_tooltip, { title: "Arraste para cima ou para baixo para ordenar os itens" }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", _hoisted_13, [
                                  _createVNode(_component_icone, { nome: "ordenar-lista" })
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_tooltip, { title: "Deletar" }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  class: "ui-action",
                                  onClick: ($event: any) => (_ctx.removerItem(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "excluir" })
                                ], 8, _hoisted_14)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ])
                      ]))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]))
        ]),
        _: 1
      })
    ])
  ]))
}